export class UnitType{
    id: number;
    name: string;
    description: string;
    unitBeddingTypes: string[];
    adultOccupancy: number;
    childOccupancy: number;
    isSelected: boolean;
    unitTypeDescriptionId: number;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-availability-v2/unit-type.model.ts